import React from 'react';
import styled from 'styled-components';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';

export default class CustomDropdown extends React.Component{
    constructor(props){
        super(props);
        this._onSelect = this._onSelect.bind(this);
    }
    
    _onSelect (option) {
        console.log(option); 

        this.setState({selected: option})
    }

    render() {
        const {category, onChange, selected} = this.props; 
        var defaultOption = "";
        var options = [];
        var placeholder="";         

        const milestones = ["Day 0", "6 Months", "1 Year", "1.5 Years", "2 Years", "2.5 Years", "3 Years", "4 Years", "View All"];
        const outcomes = ["Overall Survival Rate", "Survival in CR1", "Survival With Relapse", "aGvHD", "cGvHD"];

        if (category == "milestones"){
            options = milestones; 
        } else {
            options = outcomes;
        }

        if (selected == ''){
            placeholder="Select an option";
        } else if(selected == "Comparing All Rates"){
            placeholder="View All";
        } else{
            placeholder=selected;
        }

        return (
            <Dropdown options = {options} onChange={onChange} value={defaultOption} placeholder={placeholder} className={category + "Dropdown"}>
            </Dropdown>
        );
    }
}

export const DropdownView = (category, onChange, selected) => (
    <CustomDropdown category={category} onChange={onChange} selected={selected}></CustomDropdown>
)